import styled from 'quickstart/styled-components/system'
import {fieldStyles} from 'quickstart/utils'

export const Input = styled.input`
  ${
    // @ts-expect-error
    fieldStyles
  };
`
